$(document).ready(function () {
  $(".ancment-slider").slick({
    slidesToShow: 3.75,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    dots: false,
    arrows: false,
    pauseOnHover: false,
    arrows: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
$(document).on("click", "#mak-atc", function () {
  var $button = $(this);
  var $loadingState = $button.find(".btn-state-loading");
  var $readyState = $button.find(".btn-state-ready");
  var $completeState = $button.find(".btn-state-complete");

  // Hide the ::after pseudo-element dynamically
  $button.addClass("hide-pseudo");

  // Show loading state
  $readyState.css({ visibility: "hidden", opacity: 0 });
  $loadingState.css({ visibility: "visible", opacity: 1 });
  $button.attr("disabled", true);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: { id: $button.attr("variant-id"), quantity: 1 },
    success: function (product) {
      console.log("Product added to the cart successfully:", product);

      // Transition to complete state
      $loadingState.css({ visibility: "hidden", opacity: 0 });
      $completeState.css({ visibility: "visible", opacity: 1 });

      // Show the cart drawer
      var $cartDrawer = $("#drawer-cart");
      $cartDrawer.removeClass("display-none").addClass("drawer--visible");

      // Add overflow hidden to body
      $("body").css("overflow", "hidden");

      // Dispatch theme events
      const cartChangeEvent = new CustomEvent("theme:cart:change", {
        detail: { product: product },
      });
      document.dispatchEvent(cartChangeEvent);

      if (window.drawer) {
        window.drawer.dispatchEvent(
          new CustomEvent("theme:drawer:open", {
            detail: {
              variant: product.variant_id,
              reinit: true,
            },
            bubbles: true,
          })
        );
      } else {
        document.dispatchEvent(
          new CustomEvent("theme:cart:reload", { bubbles: true })
        );
      }

      // Reset button after a delay
      setTimeout(function () {
        $completeState.css({ visibility: "hidden", opacity: 0 });
        $readyState.css({ visibility: "visible", opacity: 1 });
        $button.removeAttr("disabled");

        // Restore ::after pseudo-element visibility
        $button.removeClass("hide-pseudo");
      }, 3500); // Adjust the delay as needed
    },
    error: function (resp) {
      console.error(
        "Error adding product to the cart:",
        resp.responseJSON?.description || "Unknown error"
      );
      alert("Failed to add product to the cart. Please try again.");

      // Reset button to ready state
      $loadingState.css({ visibility: "hidden", opacity: 0 });
      $readyState.css({ visibility: "visible", opacity: 1 });
      $button.removeAttr("disabled");

      // Restore ::after pseudo-element visibility
      $button.removeClass("hide-pseudo");
    },
  });

  // Optional: Close drawer and reset overflow hidden
  $(document).on("click", ".drawer-close, #drawer-cart", function () {
    var $cartDrawer = $("#drawer-cart");
    $cartDrawer.removeClass("drawer--visible").addClass("display-none");
    $("body").css("overflow", "auto");
  });
});
